import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainComponent = _resolveComponent("MainComponent")!
  const _directive_motion_fade_in = _resolveDirective("motion-fade-in")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_MainComponent, null, null, 512), [
      [_directive_motion_fade_in]
    ])
  ]))
}